// extracted by mini-css-extract-plugin
export var ImageKeepRatioForIE_Container = "default-module--ImageKeepRatioForIE_Container--YfIrc";
export var ImageKeepRatioForIE_Inner = "default-module--ImageKeepRatioForIE_Inner--7Cgli";
export var ImageKeepRatio_Container = "default-module--ImageKeepRatio_Container--eb9iJ";
export var ImageKeepRatio_Image = "default-module--ImageKeepRatio_Image--yEQTC";
export var Link = "default-module--Link--8GrHA";